import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503cb1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = {
  id: "modal-title",
  class: "modal__title"
}
const _hoisted_3 = {
  role: "heading",
  "data-test": "title"
}
const _hoisted_4 = {
  id: "modal-body",
  class: "modal__body",
  "data-test": "modal-body"
}
const _hoisted_5 = {
  key: 0,
  "data-test": "content"
}
const _hoisted_6 = {
  class: "modal__actions",
  "data-test": "actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", {
    "data-test": "modal",
    class: "modal",
    role: "dialog",
    "aria-labelledby": "modal-title",
    "aria-describedby": "modal-body",
    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
    ref: "modal"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title || _ctx.$t("modal.default_title")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.content), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
          return (_openBlock(), _createBlock(_component_app_button, {
            key: action.label,
            onClick: action.handler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(action.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        (!_ctx.actions)
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 0,
              "aria-label": _ctx.$t('modal.label_close'),
              onClick: _ctx.dismiss
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.ok")), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "modal__backdrop",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
      tabindex: "-1",
      "data-test": "modal-backdrop"
    })
  ], 544))
}